// extracted by mini-css-extract-plugin
export default {"long_label":"ViewPredictionsModal_long_label__-t8-V"};